/**
 * Scaffolding. Every page under src/pages/ renders this until it is built.
 *
 * It prints the route params it received, which is the point: clicking through
 * the app shows at a glance that :venueSlug and :id are being parsed and
 * handed to the right component, rather than every route rendering an
 * indistinguishable "coming soon".
 */

import { useParams } from 'react-router-dom';

export default function PagePlaceholder({ title, note, children }) {
  const params = useParams();
  const entries = Object.entries(params).filter(([, v]) => v !== undefined);

  return (
    <div className="hd-stack">
      <div>
        <h1 className="hd-page-title">{title}</h1>
        <p className="hd-meta">{note ?? 'Coming soon.'}</p>
      </div>

      {entries.length > 0 && (
        <div className="hd-card">
          <div className="hd-tile-label">Route parameters</div>
          <table className="hd-table" style={{ marginTop: 8 }}>
            <tbody>
              {entries.map(([key, value]) => (
                <tr key={key}>
                  <td style={{ width: 140 }} className="hd-muted">{key}</td>
                  <td>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {children}
    </div>
  );
}
